import { z } from 'zod';
import { SecurityLevel } from '../../shared/index.js';
export const legislativeItemDocumentUpdateSchema = z.object({
    securityLevel: z.enum(SecurityLevel),
    includeInAttachmentsList: z.boolean().optional(),
    allowedUserIds: z.preprocess((val) => (Array.isArray(val) ? val : []), z.array(z.number().int().positive())),
});
